import { ProcessedRequestRepo } from "../domain/ProcessedRequestRepo";
import { ProcessedRequest } from "../domain/ProcessedRequest";

export interface LoadProcessedRequestsHistoryScreenData {
  history: ProcessedRequest[];
  ui_loading: boolean;
  error_message?: string;
}


export class LoadProcessedRequestsHistoryQuery {
  constructor(
    private processedRequestRepo: ProcessedRequestRepo,
    private screenData: LoadProcessedRequestsHistoryScreenData
  ) {}


  async execute(limit: number = 50, offset: number = 0): Promise<void> {
    this.screenData.ui_loading = true;
    this.screenData.error_message = undefined;

    try {
      const history = await this.processedRequestRepo.find_all(limit, offset);
      this.screenData.history = history;
    } catch (error: any) {
      this.screenData.error_message = error.message || 'Error al cargar el historial';
      this.screenData.history = [];
    } finally {
      this.screenData.ui_loading = false;
    }
  }

  async executeByType(type: 'absence' | 'clock_modification', limit: number = 50, offset: number = 0): Promise<void> {
    this.screenData.ui_loading = true;
    this.screenData.error_message = undefined;

    try {
      const history = await this.processedRequestRepo.find_by_type(type, limit, offset);
      this.screenData.history = history;
    } catch (error: any) {
      this.screenData.error_message = error.message || 'Error al cargar el historial';
      this.screenData.history = [];
    } finally {
      this.screenData.ui_loading = false;
    }
  }

  async executeByStatus(status: 'approved' | 'rejected', limit: number = 50, offset: number = 0): Promise<void> {
    this.screenData.ui_loading = true;
    this.screenData.error_message = undefined;

    try {
      const history = await this.processedRequestRepo.find_by_status(status, limit, offset);
      this.screenData.history = history;
    } catch (error: any) {
      this.screenData.error_message = error.message || 'Error al cargar el historial';
      this.screenData.history = [];
    } finally {
      this.screenData.ui_loading = false;
    }
  }
}
